import React, { Component } from 'react'
import { connect } from 'react-redux'
// import usericon from "../../assets/images/user.png";
import LogoutButton from './logoutbutton';
import ButtonLoader from '../btnloader';
import BookingInput from '../Booking/bookinginput';
import {changePassword} from "../../actions/storeActions"
import {ajaxerrmsg} from "../../actions/http"
import {addToast} from "../../actions";

const intialState = {
    password: '',
    password_err: '',
    current_password: '',
    current_password_err: '',
    retype_password: '',
    retype_password_err: ''
}

class ChangePwd extends Component {

    state = intialState;

    handleChange = (e) => {
        let {value, name} = e.target;
        this.setState({
            [name]: value,
            [name+"_err"]: ''
        })
    }
    
    handleSubmit = (e) => {
        e.preventDefault();
        let {password, current_password,  retype_password} = this.state;
        if(current_password.length < 6){
            this.setState({
                current_password_err: 'Password must be atleast 6 characters'
            })
            return;
        }
        if(password.length < 6){
            this.setState({
                password_err: 'Password must be atleast 6 characters'
            })
            return;
        }
        if(retype_password.length < 6){
            this.setState({
                retype_password_err: 'Password must be atleast 6 characters'
            })
            return;
        }
        if(retype_password !== password){
            this.setState({
                retype_password: 'Passwords do not match'
            })
            return;
        }
        this.props.changePassword({password, current_password});
    }

    render() {
        let {password, password_err, current_password, current_password_err, retype_password, retype_password_err} = this.state;
        return (
            <div className="container-fluid">
                <div className="flex-between">
                    <h3 className="header-underline">Change Password</h3>
                    <LogoutButton />
                </div>
                <form className="m-t-20" noValidate onSubmit={this.handleSubmit}>
                    <div className="row">
                        <BookingInput
                            onPaste={(e) => e.preventDefault()}
                            size={12}
                            onChange={this.handleChange}
                            value={current_password}
                            err={current_password_err}
                            type="password"
                            name="current_password"
                            placeholder="Old password"
                        />
                        <BookingInput
                            onPaste={(e) => e.preventDefault()}
                            size={12}
                            onChange={this.handleChange}
                            value={password}
                            err={password_err}
                            type="password"
                            name="password"
                            placeholder="New password"
                        />
                        <BookingInput
                            onPaste={(e) => e.preventDefault()}
                            size={12}
                            onChange={this.handleChange}
                            value={retype_password}
                            err={retype_password_err}
                            type="password"
                            name="retype_password"
                            placeholder="Re-type password"
                        />
                        <div className="col-md-12">
                            <button 
                                type='submit'
                                disabled={password && current_password && retype_password &&!this.props.changePwd.fetching ? false : true}
                                className="btn btn-block btn-ouja m-b-5 m-t-10"
                                onSubmit={this.handleSubmit}
                            >
                                {this.props.changePwd.fetching ? <ButtonLoader /> : 'Submit'}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        )
    }

    componentDidUpdate(prevProps){
        if(this.props.changePwd.data && !prevProps.changePwd.data){
            this.props.addToast("Password changed successfully");
            this.setState({
                ...intialState
            })   
        }
        if(this.props.changePwd.error && !prevProps.changePwd.error){
            this.props.addToast(ajaxerrmsg(this.props.changePwd.error), false);
        }
    }
}

const mapStateToProps = ({loginReducer, changePwd}) => ({
    user: loginReducer,
    changePwd
})

const mapDispatchToProps = {
    changePassword,
    addToast
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePwd)

